import { useEffect, useMemo, useState } from "react";

export const useExportColumnsSelection = (columns) => {
	const [columnsSelected, setColumnsSelected] = useState(columns);

	useEffect(() => {
		setColumnsSelected(columns);
	}, [columns]);

	const excludedColumns = useMemo(
		() => columns.filter((column) => !columnsSelected.includes(column)),
		[columns, columnsSelected]
	);

	return { columnsSelected, setColumnsSelected, excludedColumns };
};
